import React, { useContext, useState } from 'react'

export interface contextProps {
    children: React.ReactNode
}

// Create context with empty object as default value
const ClaimContext = React.createContext<any>({})
const ClaimUpdateContext = React.createContext<any>(() => {})

export function useClaimData() {
    const contextValue = useContext(ClaimContext)
    // Return an empty object if context is null or undefined
    return contextValue || {}
}

export function useUpdateClaimData() {
    return useContext(ClaimUpdateContext)
}

export function ClaimProvider({ children }: contextProps) {
    // Initialize with empty object instead of undefined
    const [claimData, setClaimData] = useState<any>({})

    function updateClaim(cd: any) {
        console.log('Updating claim data in context:', cd)
        setClaimData(cd)
    }

    return (
        <ClaimContext.Provider value={claimData}>
            <ClaimUpdateContext.Provider value={updateClaim}>{children}</ClaimUpdateContext.Provider>
        </ClaimContext.Provider>
    )
}
